import gql from 'graphql-tag'
import { TEST } from '../gql/TEST'
import { client } from '../client'
import {getBrands} from './getBrands'


export const Mutation = {
  getBrands
}